import { Link } from "react-router-dom";
import { ArrowLeft, Radar } from "lucide-react";

/**
 * Slim "Voltar ao Hub de Radares" pill, designed to sit at the top-right
 * of every individual Radar page (Notícias, Normativo, Doutrinário).
 *
 * Without this anchor, returning visitors who land directly on a Radar
 * via a shared link have no obvious path back to the central /radar hub
 * that lists all three — they have to use the browser back button or
 * the main nav (which is two clicks away on mobile). One pill, one
 * click, no ambiguity.
 *
 * Accent color is parameterised so each Radar can match its own visual
 * identity (sky for Notícias, violet for Normativo, amber for Doutrinário).
 */
export default function RadarHubBackLink({ accent = "slate", testid = "back-to-radar-hub" }) {
  const palette = {
    sky:    "border-sky-500/40 bg-sky-500/[0.06] text-sky-200 hover:bg-sky-500/15 hover:border-sky-400/70",
    violet: "border-violet-500/40 bg-violet-500/[0.06] text-violet-200 hover:bg-violet-500/15 hover:border-violet-400/70",
    amber:  "border-amber-500/40 bg-amber-500/[0.06] text-amber-200 hover:bg-amber-500/15 hover:border-amber-400/70",
    emerald:"border-emerald-500/40 bg-emerald-500/[0.06] text-emerald-200 hover:bg-emerald-500/15 hover:border-emerald-400/70",
    slate:  "border-slate-700 bg-slate-900/60 text-slate-300 hover:bg-slate-800 hover:text-white",
  }[accent] || "border-slate-700 bg-slate-900/60 text-slate-300 hover:bg-slate-800 hover:text-white";

  return (
    <Link
      to="/radar"
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold whitespace-nowrap transition shrink-0 ${palette}`}
      aria-label="Voltar ao Hub de Radares"
    >
      <ArrowLeft className="w-3.5 h-3.5" />
      <Radar className="w-3.5 h-3.5" />
      Hub de Radares
    </Link>
  );
}
